import { DropdownOption } from "../components/common/ButtonDropdown";

// Badge color types for CloudScape Design System
export enum BadgeColor {
  BLUE = "blue",
  GREEN = "green", 
  GREY = "grey",
  RED = "red",
  SEVERITY_CRITICAL = "severity-critical",
  SEVERITY_HIGH = "severity-high",
  SEVERITY_MEDIUM = "severity-medium",
  SEVERITY_LOW = "severity-low",
  SEVERITY_NEUTRAL = "severity-neutral"
}

// Mock data for report download formats
export const MOCK_DOWNLOAD_FORMATS: DropdownOption[] = [
  {
    id: "word",
    label: "Word",
  },
];

// Mock data for report filters
export const MOCK_REPORT_FILTERS = {
  "Marketplace": ["US", "CA", "MX"],
  "Channel": ["Retail", "FBA"],
  "Product Line": ["Electronics", "Home & Garden"],
  "Period": ["Q3 2024"],
  "Scenario": ["Actual vs OP2"]
};
